import { createForm as createValidatingForm } from 'svelte-forms-lib';
export const formContextKey = {};
export function createForm(formProps) {
    return createValidatingForm(formProps);
}
